import { Link } from 'react-router-dom';

const CTA_IMAGE =
  'https://roadtechservices.netlify.app/images/mower_banner-850w.jpeg';

export default function CTASection() {
  return (
    <section className="relative py-28 lg:py-40 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={CTA_IMAGE}
          alt="Road Tech Services mobile repair at work"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/78" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <p className="text-orange-400 text-xs font-bold uppercase tracking-widest mb-4">
          Ready to Get Started?
        </p>
        <h2 className="font-display text-5xl lg:text-6xl font-bold uppercase tracking-tight text-white mb-5 leading-tight">
          Get Your Equipment Repaired Today
        </h2>
        <p className="text-white/75 text-base leading-relaxed mb-10 max-w-xl mx-auto">
          Don&rsquo;t waste time hauling your mower, snow blower, or generator
          to a shop. Contact Road Tech Services for professional, same-day
          mobile repair.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/contact"
            className="bg-orange-600 hover:bg-orange-700 text-white font-semibold px-8 py-4 rounded-lg transition-colors whitespace-nowrap text-sm cursor-pointer"
          >
            Contact Us
          </Link>
          <Link
            to="/consultation"
            className="bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold px-8 py-4 rounded-lg transition-colors whitespace-nowrap text-sm backdrop-blur-sm cursor-pointer"
          >
            Book a Consultation Call
          </Link>
        </div>
      </div>
    </section>
  );
}
